import CheckItems from "./CheckItems";
import FireboardTip from "./FireboardTip";
import cn from 'classnames';
import styles from './checkDetail.module.scss';
import MoreAction from '@assets/images/Fireboard/MoreAction';
import Expand from '@assets/images/Fireboard/Expand';
import { ReactComponent as PhoneIcon } from '@assets/images/Fireboard/call.svg';
import { getTimeInHrsMins } from '@utility/fireboardUtil';
import { getFormatedPhoneNumber } from '@utility/helperFunction';
import constant from '@components/common/globalization';

const modeSectionVisibility = {
    "DEFAULT": { order: true, delivery: true },
    "ON_PREMISE": { order: false, delivery: false },
    "OFF_PREMISE": { order: true, delivery: true },
    "OFF_PREMISE_VENUE": { order: true, delivery: true },
    "TABLE_DELIVERY": { order: false, delivery: false },
    "FUTURE_ORDERS": { order: true, delivery: true },
};

const DisplaySection = ({ mode, section, children }) => {
    if (!modeSectionVisibility[mode]?.[section]) return null;
    return children;
};

const getFormattedDateTime = (field) => {
    if (field) {
        const date = new Date(field);
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const time = getTimeInHrsMins(field);
        return `${month}/${day} ${time}`;
    }
    return '';
};

const CheckSection = ({ selectedItem, setIsFlip, isFlip, setIsExpanded, setTraceClick }) => {
    return (
        <div>
            <div className={cn('px-0 col-12 d-flex')}>
                <div className="col-9 px-0 d-flex align-items-center flex-nowrap">
                    <div className={cn(styles.checkNumber, selectedItem?.number?.length > 13 ? styles.checkTruncate : '')}>{selectedItem?.number}</div>
                    <div className={cn(styles.verticalLine)}>|</div>
                    <div
                        className={cn(styles.headerFont, 'fw-400', styles.truncate)}
                    >
                        {selectedItem?.employeeFirstName} {selectedItem?.employeeLastName}
                    </div>
                </div>
                <div className='col-3 px-0 row mx-0 justify-content-end'>
                    <div onClick={() => { selectedItem && setIsExpanded((prev) => !prev); setTraceClick(constant.EXPAND_VIEW) }} className={cn(styles.iconBox, 'mr-2', !selectedItem && styles.actionBtnContainerDisabled)}><Expand /></div>
                    <div className={cn(styles.iconBox, !selectedItem && styles.actionBtnContainerDisabled)} onClick={() => { selectedItem && setIsFlip(!isFlip); setTraceClick(constant.CHECK_DETAILS_VIEW); }}><MoreAction /></div>
                </div>
            </div>
            <div>
                <span>{selectedItem?.openDateDetails?.openDate}</span>
                <span className='px-1'>|</span>
                <span>{selectedItem?.openDateDetails?.closeDate}</span>
            </div>
        </div>
    );
};

const OrderSection = ({ selectedItem }) => {
    let orders = '';
    if (selectedItem?.orders && selectedItem?.orders?.length > 0) {
        orders = selectedItem.orders[0];
    };
    return (
        <div>
            <div className={cn('col-12 row px-0 mx-0 fw-500', styles.headerFont)}>
                <div className='col-7 px-0 text-truncate'>{selectedItem?.name || 'Order Name'}</div>
                <div className='col-5 px-0 text-right'>
                    <span className={cn(styles.phoneContainer)}>
                        <PhoneIcon />
                    </span>
                    {selectedItem?.unFormattedPhoneNumber ? selectedItem?.guestDetails?.phoneNumber : '\u00A0'.repeat(20)}
                </div>
            </div>
            <div className={cn('col-12 row px-0 mx-0 fw-500')}>
                <div className='col-7 px-0'>
                    {getFormattedDateTime(selectedItem?.pickupDate) || '---'}
                </div>
                <div className='col-5 px-0 text-right'>
                    {orders?.vehicleInfo || '---'}
                </div>
            </div>
            <div className={cn('col-12 row px-0 mx-0 fw-500')}>
                <div className='col-12 px-0'>
                    {orders?.orderNote || '---'}
                </div>
            </div>
        </div>
    );
};

const DeliverySection = ({ selectedItem }) => {
    let orders = '';
    if (selectedItem?.orders && selectedItem?.orders?.length > 0) {
        orders = selectedItem.orders[0];
    };
    return (
        <div>
            <div className="col-12 row px-0 mx-0 fw-500">
               {orders?.address || '---'}  
            </div>
            <div className={cn('col-12 row px-0 mx-0 fw-500', styles.headerFont)}>
                <div className='col-7 px-0'>{orders?.marketplaceVendorName || '---'}</div>
                <div className='col-5 px-0 text-right'>
                    <span className={cn(styles.phoneContainer)}>
                        <PhoneIcon />
                    </span>
                    {orders?.marketplacePhoneNumber ? getFormatedPhoneNumber(orders?.marketplacePhoneNumber) : '\u00A0'.repeat(20)}
                </div>
            </div>
            <div className={cn('col-12 row px-0 mx-0 fw-500')}>
                {/* <div className='col-7 px-0'>
                    {orders?.address || '---'}
                </div> */}
                <div className='col-5 px-0 text-left'>
                    {orders?.marketplaceOrderId ? `Order#${orders?.marketplaceOrderId}` : '---'}
                </div>
            </div>
        </div>
    );
};

const CheckDetailContent = ({
    selectedItem,
    setIsFlip,
    isFlip,
    currency,
    supportsTipsOnTotalAmount,
    suppressTipsOnFireBoard,
    mode,
    setPopup,
    setIsExpanded,
    setTraceClick,
}) => (
    <div
        className={cn(
            'w-100 h-100',
            styles.frontSide,
            styles.side,
            styles.bodyTextFont
        )}
    >
        <CheckSection
            selectedItem={selectedItem}
            setIsFlip={setIsFlip}
            isFlip={isFlip}
            setPopup={setPopup}
            setIsExpanded={setIsExpanded}
            setTraceClick={setTraceClick}
        />
        <hr className={styles.customHr} />

        <DisplaySection mode={mode} section="order">
            <OrderSection selectedItem={selectedItem} />
            <hr className={styles.customHr} />
        </DisplaySection>

        <DisplaySection mode={mode} section="delivery">
            <DeliverySection selectedItem={selectedItem} />
            <hr className={styles.customHr} />
        </DisplaySection>

        <div className={cn((!modeSectionVisibility[mode]?.order && !modeSectionVisibility[mode]?.delivery) ? styles.CheckItemsWithoutOrderAndDelivery : styles.CheckItems, 'col-12 px-0')}>
            <CheckItems
                itemslist={selectedItem?.AllItems}
                currency={currency}
                selectedItem={selectedItem}
            />
        </div>
        <FireboardTip
            selectedItem={selectedItem}
            supportsTipsOnTotalAmount={supportsTipsOnTotalAmount}
            currency={currency}
            suppressTipsOnFireBoard={suppressTipsOnFireBoard}
        />
    </div>
);

export default CheckDetailContent;
